import React from 'react';
import './advanced-protection-row.scss';
import { AdvancedProtectionStatus } from './advanced-protection-status';

export const AdvancedProtectionRow: React.FC<{ type: string, value: string }> = ({ type, value }) => (
    <div className="advanced-protection-row">
        <div className="cell type">{type} Protection</div>
        <AdvancedProtectionStatus value={value} />
    </div>
);